"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joiErrorResult = exports.enumKeyToArray = exports.enumToArray = exports.computedFormattingStr = exports.computedFormatting = exports.datasheetIdString = void 0;
const joi_1 = __importDefault(require("joi"));
const types_1 = require("../../../types");
const datasheetIdString = () => joi_1.default.string().pattern(/^dst.+/, 'datasheetId');
exports.datasheetIdString = datasheetIdString;
const computedFormatting = () => joi_1.default.allow(joi_1.default.object({
    dateFormat: joi_1.default.valid(...enumToArray(types_1.DateFormat)),
    timeFormat: joi_1.default.valid(...enumToArray(types_1.TimeFormat)),
    includeTime: joi_1.default.boolean(),
}), joi_1.default.object({
    formatType: joi_1.default.valid(...enumToArray(types_1.SymbolAlign)),
    precision: joi_1.default.number().integer().min(0).max(10),
    symbol: joi_1.default.string(),
    commaStyle: joi_1.default.string(),
}));
exports.computedFormatting = computedFormatting;
const computedFormattingStr = () => joi_1.default.allow(joi_1.default.object({
    dateFormat: joi_1.default.valid(...enumKeyToArray(types_1.DateFormat)),
    timeFormat: joi_1.default.valid(...enumKeyToArray(types_1.TimeFormat)),
    includeTime: joi_1.default.boolean(),
}), joi_1.default.object({
    precision: joi_1.default.number().integer().min(0).max(10),
    symbol: joi_1.default.string(),
    commaStyle: joi_1.default.string(),
}));
exports.computedFormattingStr = computedFormattingStr;
const stringIsNumber = (value) => isNaN(Number(value)) === false;
function enumToArray(en) {
    const keys = Object.keys(en).filter(k => !stringIsNumber(k));
    return keys.map(k => en[k]);
}
exports.enumToArray = enumToArray;
function enumKeyToArray(en) {
    return Object.keys(en);
}
exports.enumKeyToArray = enumKeyToArray;
function joiErrorResult(message, value) {
    return {
        error: { message },
        value
    };
}
exports.joiErrorResult = joiErrorResult;
//# sourceMappingURL=index.js.map